// extracted by mini-css-extract-plugin
export default {"captcha":"YVeOu","reset":"QKiBm"};